import { useQuery } from "@tanstack/react-query"
import { getUser } from "@/actions/user/user.action"

export const useAgent = (agentId: string) => {
  return useQuery({
    queryKey: ["agent", agentId],
    queryFn: async () => {
      const res = await getUser(agentId)
      if (!res.data?.data) throw new Error("Agent not found")
      return res.data.data
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
